import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { verificarActivacion } from "../services/api";
import nfcAuthService from '../services/nfcAuthService';

function Verificar() {
  const [searchParams] = useSearchParams();
  const codigoAcceso = searchParams.get("activacion");

  const [cargando, setCargando] = useState(true);
  const [mensaje, setMensaje] = useState("");

  useEffect(() => {
    async function doVerify() {
      setCargando(true);
      setMensaje("");

      if (!codigoAcceso) {
        setMensaje("No se proporcionó un código de acceso en la URL (?activacion=XYZ).");
        setCargando(false);
        return;
      }

      try {
        // Llamamos a la función de verificación
        const resp = await verificarActivacion(codigoAcceso);

        if (resp.error) {
          // Error desde el backend
          setMensaje(`Error: ${resp.error}`);
        } else if (resp.success) {
          // Caso éxito
          if (resp.modo === "ligar") {
            // El backend nos indica que es un objeto en "pendientePorLigar"
            setMensaje("Este objeto está en modo ligando. Faltan datos por capturar.");
            // O hacer: window.location.href = "/verificarSiguiente?activacion="+codigoAcceso;
          } else {
            // Verificación exitosa para nuevo usuario
            setMensaje('¡Verificación exitosa! Redirigiendo a tu panel...');
            
            // Verificar si tenemos token
            if (resp.token) {
              // Usar el servicio de autenticación para guardar sesión
              nfcAuthService.loginConDatos(resp.token, {
                id: resp.usuario.id,  // Usar 'id' no 'uid'
                correo: resp.usuario.correoPropietario || '',  // Leer de resp.usuario
                nombre: resp.usuario.nombrePropietario || '',   // Leer de resp.usuario
                nombrePropietario: resp.usuario.nombrePropietario || ''
              });
              
              // Redirigir después de guardar la sesión
              setTimeout(() => {
                window.location.href = `/userpanel?doc=${ resp.usuario.id}&token=${resp.token}`;
              }, 2000);
            } else {
              // No hay token - posiblemente el backend no lo está generando
              setMensaje("Verificación completada pero no se pudo crear sesión. Por favor intenta iniciar sesión manualmente.");
              setTimeout(() => {
                window.location.href = `/login`;
              }, 3000);
            }
          }
        } else {
          // success = false, o caso no manejado
          if (resp.message) {
            setMensaje(resp.message);
          } else {
            setMensaje("La verificación no se pudo completar.");
          }
        }
      } catch (err) {
        setMensaje("Ocurrió un error al verificar en el servidor: " + err.message);
      } finally {
        setCargando(false);
      }
    }

    doVerify();
  }, [codigoAcceso]);

  if (cargando) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h3>Verificando tu cuenta...</h3>
        <p>Por favor espera un momento.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h3>Verificación de Lemmon Tags</h3>
      <div style={{ marginTop: '2rem', fontSize: '1.1rem' }}>
        <p>{mensaje}</p>
      </div>
    </div>
  );
}

export default Verificar;